<h1 mat-dialog-title>Delete</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete {{ data.deleteContext }} ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ delete: true }">Confirm</button>
</mat-dialog-actions>
